import React, {useEffect} from "react";
import "./PaytikoCashier.scss";

const PaytikoCashier = ({sessionToken, orderId}) => {
  const IFRAME_CONTAINER_SELECTOR = "div#cashier-iframe-container";
  const LOCALE = "en-US";

  useEffect(() => {
    const invokePaytiko = () => {
      if (window.PaytikoSdk && window.PAYTIKO_CASHIER_DISPLAY_MODE) {
        window.PaytikoSdk.cashier.invoke({
          environment: "PRODUCTION", // or 'PRODUCTION' for live
          orderId: orderId,
          sessionToken: sessionToken,
          iframeContainerSelector: IFRAME_CONTAINER_SELECTOR,
          displayMode: window.PAYTIKO_CASHIER_DISPLAY_MODE.IFRAME,
          locale: LOCALE,
        });
      }
    };

    // Dynamically load the Paytiko SDK
    const script = document.createElement("script");
    script.src = "https://core.paytiko.com/cdn/js/sdk/paytiko-sdk.1.0.min.js";
    script.async = true;
    script.onload = invokePaytiko;

    document.body.appendChild(script);

    return () => {
      // Clean up the script tag when the component unmounts
      document.body.removeChild(script);
    };
  }, [sessionToken, orderId]); // Re-invoke when sessionToken or orderId changes

  return <div id="cashier-iframe-container" />;
};

export default PaytikoCashier;
